import theme from "@chakra-ui/theme";
import Accordion from "./themedComponents/accordion";
import Alert from "./themedComponents/alert";
import Avatar from "./themedComponents/avatar";
import Badge from "./themedComponents/badge";
import Button from "./themedComponents/button";
import Checkbox from "./themedComponents/checkbox";
import Form from "./themedComponents/form";
import FormLabel from "./themedComponents/form-label";
import Input from "./themedComponents/input";
import Modal from "./themedComponents/modal";
import Radio from "./themedComponents/radio";
import Slider from "./themedComponents/slider";
import Switch from "./themedComponents/switch";
import Tabs from "./themedComponents/tabs";
import Tooltip from "./themedComponents/tooltip";
var hometimeTheme = Object.assign({}, theme, {
  styles: {
    global: function global(props) {
      return Object.assign({}, theme.styles.global({
        colorMode: "light"
      }), {
        "*, *::before, &::after": {
          borderColor: "gray.400",
          wordWrap: "break-word",
          "-webkit-tap-highlight-color": "transparent"
        },
        "*::placeholder": {
          color: "gray.600"
        }
      });
    }
  },
  fonts: {
    body: "DM Sans, sans-serif",
    heading: "Public Sans, sans-serif",
    mono: "Menlo, Consolas, Monaco, Liberation Mono, monospace"
  },
  colors: Object.assign({}, theme.colors, {
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    red: {
      100: "#FCD5DB",
      200: "#FF4965",
      300: "#B41A32",
      400: "#740012"
    },
    orange: {
      100: "#FBDFBB",
      200: "#DA8D29",
      300: "#BD6C02",
      400: "#643800"
    },
    yellow: {
      100: "#F9ECC0",
      200: "#ECC94B",
      300: "#D69E2E",
      400: "#5F4D0E"
    },
    teal: {
      100: "#DCF6EA",
      200: "#39B0A4",
      300: "#07635A",
      400: "#00342F"
    },
    green: {
      100: "#D0F3DB",
      200: "#48BB78",
      300: "#276749",
      400: "#1C4532"
    },
    ocean: {
      100: "#BBE6EC",
      200: "#39A2B0",
      300: "#096E7C",
      400: "#00333A"
    },
    blue: {
      100: "#CEEDFF",
      200: "#4299E1",
      300: "#1E4E8C",
      400: "#1A365D"
    },
    purple: {
      100: "#E9E5FF",
      200: "#805AD5",
      300: "#553C9A",
      400: "#322659"
    },
    pink: {
      100: "#FFE4EC",
      200: "#FE9ABD",
      300: "#97266D",
      400: "#521B41"
    },
    gray: {
      100: "#FAFBFB",
      200: "#F8F8FA",
      300: "#E9EAED",
      400: "#E2E4E7",
      500: "#CBCED2",
      600: "#A4A8B0",
      700: "#5E6573",
      800: "#303541",
      900: "#242427"
    }
  }),
  fontSizes: {
    "2xs": "0.625rem",
    // 10px
    xs: "0.75rem",
    // 12px
    sm: "0.875rem",
    // 14px
    md: "1rem",
    // 16px
    lg: "1.25rem",
    // 20px
    xl: "1.5rem",
    // 24px
    "2xl": "2rem",
    // 32px
    "3xl": "2.5rem" // 40px

  },
  space: Object.assign({}, theme.space, {
    "7": "1.75rem",
    "14": "3.5rem",
    "15": "3.75rem",
    "18": "4.5rem",
    "25": "6.25rem",
    "90": "22.5rem",
    "124": "31rem",
    "136": "34rem"
  }),
  sizes: Object.assign({}, theme.space, {
    "7": "1.75rem",
    "14": "3.5rem",
    "15": "3.75rem",
    "18": "4.5rem",
    "25": "6.25rem",
    "90": "22.5rem",
    "124": "31rem",
    "136": "34rem"
  }, theme.sizes),
  shadows: {
    xs: "0px 0px 2px rgba(94, 101, 115, 0.24)",
    sm: "0px 1px 2px rgba(36, 36, 39, 0.24), 0px 0px 1px rgba(94, 101, 115, 0.08)",
    md: "0px 2px 4px rgba(94, 101, 115, 0.16), 0px 1px 2px rgba(94, 101, 115, 0.08)",
    lg: "0px 8px 24px rgba(164, 168, 176, 0.08), 0px 4px 8px rgba(94, 101, 115, 0.08)",
    xl: "0px 8px 32px rgba(164, 168, 176, 0.16), 0px 4px 8px rgba(94, 101, 115, 0.08)",
    "2xl": "0px 16px 40px rgba(164, 168, 176, 0.24), 0px 4px 8px rgba(94, 101, 115, 0.08)"
  },
  components: Object.assign({}, theme.components, {
    Alert: Alert,
    Avatar: Avatar,
    Accordion: Accordion,
    Badge: Badge,
    Button: Button,
    Checkbox: Checkbox,
    Form: Form,
    FormLabel: FormLabel,
    Input: Input,
    Modal: Modal,
    Radio: Radio,
    Slider: Slider,
    Switch: Switch,
    Tabs: Tabs,
    Tooltip: Tooltip
  })
});
export default hometimeTheme;
/*
    orange: {
      100: "",
      200: "",
      300: "",
      400: ""
    },
    */